var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"qiao_qi_warp"},[_c('div',{staticClass:"div_info"},[_vm._v("各社区人口分布")]),_c('div',{staticClass:"mapWarp"},[_c('div',{ref:"container",attrs:{"id":"container"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }